<template>
    <v-card>                    
        <v-card-title>
            Pending rebookings ({{ rebookings.numberOfOpenRebookings }})
            <v-spacer></v-spacer>
            <v-btn class="primary ma-2" x-small @click="showDetails()" v-if="rebookings.numberOfOpenRebookings > 0" >Details</v-btn>
        </v-card-title>
        <div style="cursor:default" class="flex px-4 pt-2 pb-4">
            <div class="column">
                <!-- By guest: <span class="col-value">{{ rebookings.numberOfOpenRebookingsGuest }}</span> -->
            </div>
            <div class="column">
                By host: <span class="col-value">{{ rebookings.numberOfOpenRebookingsHost }}</span>
            </div>  
            <div class="column">
                By Villa for You: <span class="col-value">{{ rebookings.numberOfOpenRebookingsVfy }}</span>      
            </div>  
            <div class="column">
                By caretaker: <span class="col-value">{{ rebookings.numberOfOpenRebookingsCaretaker }}</span>
            </div>              
            <div class="column">
                By Other: <span class="col-value">{{ rebookings.numberOfOpenRebookingsOther }}</span>      
            </div>
        </div>
    </v-card>
</template>

<script>
    export default {
        props: {
            entity: {
                type: String,
                default: 'all',
                required: false
            },
            encrid: {
                type: String,
                default: '',
                required: false
            },
        },
        data() {
            return {
                rebookings: {
                    numberOfOpenRebookings: 0,
                    //numberOfOpenRebookingsGuest: 0,
                    numberOfOpenRebookingsHost: 0,
                    numberOfOpenRebookingsCaretaker: 0,
                    numberOfOpenRebookingsVfy: 0,
                    numberOfOpenRebookingsOther: 0,
                },
            }
        },
        mounted() {
            this.getHombCount();
        },
        methods: {             
            getHombCount(){
                this.$axios.post("ares/json/ares/huov/homb/getHombCount.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getHombCount"
                    },
                    getHombCount: {
                        entity: this.entity,
                        encrid: this.encrid
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                        this.resulttext = res.data.error.message;
                    } else {                   
                        this.rebookings = res.data.getHombCount;         
                    }
                });   
            },   
            showDetails() {
                let route = this.$router.resolve({ path: "/task/customer_success/homb/homb_overview/" + this.entity + ":" + this.encrid}); 
                window.open(route.href, "_blank");
            },
        }
    }
</script>

<style scoped> 
.flex{
    display: flex;
    flex-direction: row;
    align-items: center;
}
.column{
  position: inherit;
  width: 20%;
}
.col-value{
  float:right; 
  font-weight: bold; 
  padding-right: 40px;
}

</style>